<!--
  - Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
  -->

<template>
  <section class="page-section">
    <div class="section-heading"><h1>What, Where?</h1></div>
    <div class="page-section-content">
      <div class="columns">
        <page-tile
          :key="`card_${idx}`"
          :to="card.to"
          class="column"
          v-for="(card, idx) in cards"
        >
          <template v-slot:image>
            <img
              :src="card.image.src"
              class="is-hoverable-image"
              :alt="card.image.alt"
            />
          </template>
          <template v-slot:title>
            <v-clamp
              autoresize
              :max-lines="1"
              class="title is-size-5-touch is-size-4 is-bold"
              >{{ card.title }}</v-clamp
            >
          </template>
          <template v-slot:subtitle>
            <v-clamp
              autoresize
              :max-lines="1"
              class="subtitle is-size-6-touch is-size-5"
            >
              {{ card.subtitle }}
            </v-clamp>
          </template>
        </page-tile>
      </div>
    </div>
  </section>
</template>
<script>
import PageTile from "./../../common/page-tile";
import VClamp from "vue-clamp";
import { ROUTE_NAMES } from "@/routes";
export default {
  computed: {
    cards() {
      return [
        {
          to: {
            name: ROUTE_NAMES.GALLERY,
            params: { id: "bc3ebc3c-253e-43a9-9243-a763708d013g" }
          },
          image: {
            src: "https://static.bz-uk.roamingowl.com/images/640/7679.webp",
            alt: "Delosperma cooperi"
          },
          title: "Blooming right now",
          subtitle: "See all the plants that are currently in bloom"
        },
        // {
        //   to: {},
        //   image: {
        //     src: 'https://static.bz-uk.roamingowl.com/images/640/7423.webp',
        //     alt: 'Duvalia caespitosa'
        //   },
        //   title: 'Bearing fruits',
        //   subtitle: 'See all the plants that are currently bearing fruits'
        // },
        {
          to: { name: ROUTE_NAMES.GARDEN_MAP },
          image: {
            src: "/img/map_preview.png",
            alt: "Map"
          },
          title: "Garden map",
          subtitle: "Open interactive map of the garden"
        }
      ];
    }
  },
  components: {
    PageTile,
    VClamp
  }
};
</script>
<style lang="scss" scoped>
@import "./../page-scoped";
</style>
